import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { BookingController } from '@shared/src/controllers/booking/booking.controller';
import { OpenRouteController } from '@shared/src/controllers/open/open.route.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { HDate } from '@shared/src/datatypes/HDate';
import { HHour } from '@shared/src/datatypes/HHour';
import { SlotActionDto } from '@shared/src/dtos/address/slots/actions/SlotActionDto';
import { BookingDto } from '@shared/src/dtos/booking/BookingDto';
import { OpenResource } from '@shared/src/dtos/open/OpenResource';
import { HDateHour, HTime, HomeController, RouteController } from '@shared/src/public-api';
import { PhaseController } from '../../../controllers/route/phase/phase.controller';
import { HHourInterval } from '../../../datatypes/HHourInterval';
import { AddressTimetableIntervalDto } from '../../../dtos/address/AddressTimetableIntervalDto';
import { iPhaseSlot } from '@shared/src/dtos/phase/iPhaseSlot';
import { PhaseSlotChangeReasonDataInfoDto } from '@shared/src/dtos/phase/slot/manage/reason/PhaseSlotChangeReasonDataInfoDto';
import { PhaseSlotChangeReasonActionTypes } from '@shared/src/enums/PhaseSlotChangeReasonActionTypes';
import { MultiSlotInfoDto } from '@shared/src/dtos/address/slots/MultiSlotInfoDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { iBooking } from '@shared/src/dtos/booking/iBooking';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { RoutePropertyController } from '@shared/src/controllers/route/properties/route.property.controller';
import { TranslateService } from '@ngx-translate/core';
import { RoutePropertyChanged } from '@shared/src/controllers/route/properties/RoutePropertyChanged';

@Component({
   selector: 'shared-slot-picker',
   templateUrl: './shared.slot.picker.component.html',
   styleUrls: ['./shared.slot.picker.component.scss']
})
export class SharedSlotPickerComponent implements OnInit {

   public useIonic: boolean = false;
   constructor(public phaseController: PhaseController,
      public openRouteController: OpenRouteController,
      public routeController: RouteController,
      public slotsController: SlotsController,
      public bookingController: BookingController,
      public routePropertyController: RoutePropertyController,
      @Inject('SecurityController') public securityController: SecurityController,
      @Inject('HomeController') public homeController: HomeController,
      public translateService: TranslateService) {
      if (homeController.useIonic)
         this.useIonic = homeController.useIonic();
   }

   @Input()
   public hideTitle: boolean = false;

   @Input()
   public booking: iBooking;

   @Input()
   public avoidPropertyPendingResponse: boolean;
   
   public _isloadconsole: boolean;
   @Input()
   public set isloadconsole(value: boolean) {
      if (this._isloadconsole == value)
         return;
      this._isloadconsole = value;
      this.calculateGeneralClass();
   }
   public get isloadconsole(): boolean {
      return this._isloadconsole;
   }


   @Input()
   public isActiveRoutes: boolean = false;

   public __phaseId: number;
   @Input()
   public set phaseId(value: number) {
      if (this.__phaseId === value)
         return;
      let equalsId = (this.__phaseId != null && value != null && this.__phaseId == value) || (this.__phaseId == null && value == null); 
      this.__phaseId = value;
      this.preLoadData(!equalsId);
   }
   public get phaseId(): number {
      return this.__phaseId;
   }

   private _phase: iPhaseSlot;
   @Input()
   public set phase(value: iPhaseSlot) {
      if (this._phase === value)
         return;
      let equalsId = (this._phase != null && value != null && this._phase.phaseId == value.phaseId) || (this._phase == null && value == null); 
      this._phase = value;
      this.calculateGeneralClass();
      if (value != null)
         this.__phaseId = value.phaseId
      else
         this.__phaseId = 0;

      if (!this._phase.slotId)
         this.preLoadData(!equalsId);
      else {
         this.loadObservacions();
         this.loadMultiSlotInfo();
      }
   }
   public get phase(): iPhaseSlot {
      return this._phase;
   }


   public loadingPendingResponse: boolean = false;
   public existsPropertiesLinkedToSlotsPendingResponse: boolean = false;
   preLoadData(withalwaysask: boolean) {
      if (!this.phase || this.loadingPendingResponse)
         return;

      if(this.avoidPropertyPendingResponse){
         this.loadingPendingResponse = false;
         this.existsPropertiesLinkedToSlotsPendingResponse = false;
         this.__loadData();
         return;
      }

      this.loadingPendingResponse = true;
      this.routePropertyController.existsPropertiesLinkedToSlotsPendingResponseByRouteId(this.phase.routeId, withalwaysask).subscribe(data => {
         this.loadingPendingResponse = false;
         this.existsPropertiesLinkedToSlotsPendingResponse = data;
         if (!this.existsPropertiesLinkedToSlotsPendingResponse) {
            this.__loadData();
         }
      });

   }

   onRefreshExistsPropertiesLinkedToSlotsPendingResponse(event: RoutePropertyChanged) {
      if (event) {
         if (!event.previousPhaseCreated && !event.actualPhaseDeleted)
            this.preLoadData(false);
         //this.valueChange.next(true);
      }
   }

   public loading: boolean = false;
   public nooptions: boolean = false;
   public showObservacions: Boolean = false;
   public realDate: HDate = null;
   public realInterval: HHourInterval = null;
   public canSlotRelease: Boolean = false;
   public canReserveOutOfHours: Boolean = false;
   public showDespositStartBooking: boolean;
   public showDespositEndBooking: boolean;

   public canShowPropertiesButton: Boolean = false;

   public parentMessage: string = "";
   private __loadData() {
      if (!this.__phaseId || this.loading)
         return;

      this.nooptions = false;
      this.intervals = null;
      this.canSlotRelease = false;
      this.canReserveOutOfHours = false;
      if (this.phase != null && !this.phase.isSlotBlocked) {
         this.loading = true;
         this.phaseController.getIntervalsByPhaseId(this.__phaseId).subscribe(data => {
            this.intervals = data;
            this.loading = false;
            this.showReservarForaHores = false;
            if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0) {
               this.nooptions = true;
            }
            this.phaseController.canReserveOutOfHoursByPhaseId(this.__phaseId).subscribe(data => {
               this.canReserveOutOfHours = data;
               this.calculateGeneralClass();
            });
         });
         this.phaseController.getCanSlotReleaseByPhaseId(this.__phaseId).subscribe(data => {
            this.canSlotRelease = data;
            if (!this.canSlotRelease && this.intervals != null && this.intervals.length == 0) {
               this.nooptions = true;
            }
            this.calculateGeneralClass();
         });
      }

      this.loadObservacions();

      if (this.phase) {
         this.routePropertyController.existsPropertiesLinkedToSlotsByRouteId(this.phase.routeId).subscribe(data => {
            this.canShowPropertiesButton = data;
            this.calculateGeneralClass();
         });
         this.bookingController.getBookingCardItemByRouteId(this.phase.routeId).subscribe(b => {
            this.booking = b;
            if (this.booking != null) {
               this.showDespositStartBooking = !HDateHour.isNullOrNullValue(this.booking.depositStart);
               this.showDespositEndBooking = !HDateHour.isNullOrNullValue(this.booking.depositEnd);
            }
            this.calculateGeneralClass();
         });
         this.phaseController.getParentPhaseBlockedReason(this.phase.phaseId).subscribe(data => {
            this.parentMessage = data;
         });
      }
   }

   loadObservacions() {
      if (this.phase != null && this.phase.intervalInfo != null && this.phase.intervalInfo.addressTimetableIntervalId != 0) {
         this.showObservacions = SharedSlotPickerComponent.getShowObservacions(this.phase.intervalInfo);
         if (this.showObservacions) {
            this.realDate = SharedSlotPickerComponent.getRealDate(this.phase.intervalInfo);
            this.realInterval = SharedSlotPickerComponent.getRealInterval(this.phase.intervalInfo);
         }
      }
   }

   loadMultiSlotInfo() {
      if (this.phase == null || this.phase.intervalInfo == null || !this.phase.intervalInfo.multiSlot || HLong.isNullOrNullLong(this.phase.slotId)) {
         this.multiSlotInfo = null;
         return;
      }

      this.slotsController.getMultiSlotInfo(this.phase.slotId).subscribe(data => {
         this.multiSlotInfo = data;
      });
   }

   reload() {
      this.preLoadData(false);
   }

   public multiSlotInfo: MultiSlotInfoDto;

   private _intervals: Array<AddressTimetableIntervalDto>
   @Input()
   public set intervals(value: Array<AddressTimetableIntervalDto>) {
      if (this._intervals === value)
         return;
      this._intervals = value;
      this.loadIntervals();
   }
   public get intervals(): Array<AddressTimetableIntervalDto> {
      return this._intervals;
   }

   public addressintervals: AddressTimetableIntervalDto[];

   @Output() public callBack: EventEmitter<any> = new EventEmitter<any>();
   @Output() public valueChange: EventEmitter<any> = new EventEmitter<any>();

   private _canviSlot: boolean;
   @Input()
   public set canviSlot(value: boolean) {
      if (this._canviSlot === value)
         return;
      this._canviSlot = value;
      this.calculateGeneralClass();
      if (value) {
         this.preLoadData(true);
      } else {
         this.showReservarForaHores = false;
      }
   }
   public get canviSlot(): boolean {
      return this._canviSlot;
   }


   ngOnInit(): void {
   }

   public toggleCanviSlot() {
      this.canviSlot = !this.canviSlot;
   }

   loadIntervals() {
      this.addressintervals = [];

      if (!this.intervals)
         return;

      if (this.intervals == null || this.intervals.length <= 0)
         return;

      this.intervals.forEach(element => {
         if (!HHourInterval.isNullOrNullValue(element.interval))
            this.addressintervals.push(element);
      });

      if (this.phase == null || this.phase.intervalInfo == null)
         return;
      if (HHourInterval.isNullOrNullValue(this.phase.intervalInfo.interval))
         return;
      /*
      * Afegeix l'interval reservat, indicat per slotInfo, quan no està present al llistat d'intervals
      * d'una fase retornats pel back.
      * */
      let isInTheList = false;
      for (const addressinterval of this.addressintervals) {
         if (addressinterval.addressTimetableIntervalId === this.phase.intervalInfo.addressTimetableIntervalId) {
            isInTheList = true;
            break
         }
      }
      if (!isInTheList) {
         this.addressintervals.push(this.phase.intervalInfo);
      }

   }

   isSelected(addressinterval: AddressTimetableIntervalDto) {
      return addressinterval != null
         && this.phase != null
         && this.phase.intervalInfo != null
         && this.phase.intervalInfo.addressTimetableIntervalId === addressinterval.addressTimetableIntervalId;
   }

   onIntervalSelected(addressinterval: AddressTimetableIntervalDto) {
      if (this.phase == null || this.phase.phaseId == null)
         return;
      if (addressinterval == null || HHourInterval.isNullOrNullValue(addressinterval.interval))
         return;
      if (this.isSelected(addressinterval))
         return;

      if (!addressinterval.assignable)
         return;

      if (!addressinterval.canSwap && !addressinterval.canObtain) {
         this.phaseController.getRequiredSlotChangeReason(this.phase.phaseId, PhaseSlotChangeReasonActionTypes.SetSlot).subscribe((data: boolean) => {
            if (data && !this.useIonic) {
               this.homeController.openAsidePhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSetSlot(this.phase.phaseId, addressinterval, this.isActiveRoutes, true)).then(value => {
                  this.callBack.next(true);
               });
            } else {
               if (addressinterval.addressTimetableIntervalId != null) {
                  this.openRouteController.phaseAllocateSlot(this.phase.phaseId, addressinterval.addressTimetableIntervalId, new Array()).subscribe((data: Boolean) => {
                     this.afterLoad(data, false);
                  });
               } else if (addressinterval.addressDaySettingResourceId != null) {
                  this.openRouteController.phaseAllocateSlotByResource(this.phase.phaseId, addressinterval.addressDaySettingResourceId, OpenResource.build(addressinterval), new Array()).subscribe((data: Boolean) => {
                     this.afterLoad(data, false);
                  });
               }
            }
         });
      } else {
         //Si tenim slot seleccionat, es un swap, sinó, un assign
         if (addressinterval.canSwap) {
            let slotAction = SlotActionDto.build(this.phase.slotId, this.phase.phaseId, addressinterval.slotIdSwap, addressinterval.phaseIdSwap, this.isActiveRoutes);
            this.phaseController.getRequiredSlotChangeReasonBySwap(slotAction).subscribe((data: boolean) => {
               if (data && !this.useIonic) {
                  this.homeController.openAsidePhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildSwap(this.phase.phaseId, slotAction, this.isActiveRoutes, true)).then(value => {
                     this.callBack.next(true);
                  });
               } else {
                  this.slotsController.swapSlots(slotAction, new Array(), true).subscribe(data => {
                     this.afterLoad(data, false);
                  });
               }
            });
         } else if (addressinterval.canObtain) {
            let slotAction = SlotActionDto.build(null, this.phase.phaseId, addressinterval.slotIdSwap, null, this.isActiveRoutes);
            this.phaseController.getRequiredSlotChangeReasonByObtain(slotAction).subscribe((data: boolean) => {
               if (data && !this.useIonic) {
                  this.homeController.openAsidePhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildObtain(this.phase.phaseId, slotAction, this.isActiveRoutes, true)).then(value => {
                     this.callBack.next(true);
                  });
               } else {
                  this.slotsController.obtainSlot(slotAction, new Array(), true).subscribe(data => {
                     this.afterLoad(data, false);
                  });
               }
            });
         }
      }
   }

   public clickAlliberarSlot() {

      if (this.phase == null || this.phase.phaseId == null || this.phase.slotId == null)
         return;

      this.phaseController.getRequiredSlotChangeReason(this.phase.phaseId, PhaseSlotChangeReasonActionTypes.CancelSlot).subscribe((data: boolean) => {
         if (data && !this.useIonic) {
            this.homeController.openAsidePhaseSlotChangeReasonManage(this.phase.phaseId, PhaseSlotChangeReasonDataInfoDto.buildCancel(this.phase.phaseId, this.isActiveRoutes, true)).then(value => {
               this.callBack.next(true);
            });
         } else {
            this.openRouteController.phaseReleaseSlot(this.phase.phaseId, this.isActiveRoutes, new Array()).subscribe((data: boolean) => {
               this.afterLoad(data, true);
            });
         }
      });
   }

   public showReservarForaHores: boolean = false;
   public toggleReservarForaHores() {
      this.showReservarForaHores = !this.showReservarForaHores;
   }
   public onReservarForaHoresFinish(data: boolean) {
      this.afterLoad(data, false);
   }

   public afterLoad(data: Boolean, canvislot: boolean) {
      if (data) {
         this.canviSlot = canvislot;
      }
      this.reload();
      this.valueChange.next(data);
   }
   public getShowObservacionsFunc = SharedSlotPickerComponent.getShowObservacions;
   public static getShowObservacions(item: AddressTimetableIntervalDto): boolean {
      if (item == null)
         return false;

      return HHour.isGreaterEqualsThan(HHourInterval.getStarts(item.interval), HHour.buildByHoursAndMinutes(24, 0));
   }
   public getRealDateFunc = SharedSlotPickerComponent.getRealDate;
   public static getRealDate(item: AddressTimetableIntervalDto): HDate {
      if (SharedSlotPickerComponent.getShowObservacions(item))
         return HDate.addDaysToHDate(item.onDate, 1);
      else
         return item.onDate;
   }
   public getRealIntervalFunc = SharedSlotPickerComponent.getRealInterval;
   public static getRealInterval(item: AddressTimetableIntervalDto): HHourInterval {
      if (SharedSlotPickerComponent.getShowObservacions(item))
         return HHourInterval.build(HHour.addHours(HHourInterval.getStarts(item.interval), -24), HHour.addHours(HHourInterval.getEnds(item.interval), -24))
      else
         return item.interval;
   }

   /***
    * True si el n-essim element item te una data diferent a l'anterior
    */
   public trencaData(i: number, item: AddressTimetableIntervalDto): boolean {
      if (i == 0)
         return true;
      let prev = this.addressintervals[i - 1];
      return !HDate.equals(item.onDate, prev.onDate);
   }

   public generalClass: string = "";
   public calculateGeneralClass() {
      this.generalClass = "";
      if (this.isloadconsole)
         this.generalClass += " loadconsole";
      if (this.canviSlot)
         this.generalClass += " canviSlot";
      if (this.phase != null && this.phase.isSlotBlocked)
         this.generalClass += " isSlotBlocked";
      if (this.phase != null && this.phase.incompatibleSlot)
         this.generalClass += " incompatibleSlot";
      if (this.phase != null && this.phase.intervalInfo != null && this.phase.intervalInfo.addressTimetableIntervalId != null && this.phase.intervalInfo.addressTimetableIntervalId != 0)
         this.generalClass += " oneSelected";
      if (this.phase != null && this.phase.isBlockedBookSlotSystem)
         this.generalClass += " isBlockedBookSlotSystem";

      this.calcularActions();
   }

   public actions: ActionsStripDto;
   public calcularActions() {
      this.actions = new ActionsStripDto();
      if (this.canReserveOutOfHours) {
         if (this.showReservarForaHores)
            this.actions.add(ActionDto.build("REESERVARFORAHORES", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.REESERVARFORAHORES.HIDDEN", "", "fa-clock-o", 50, 0, -1, ""));
         else
            this.actions.add(ActionDto.build("REESERVARFORAHORES", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.REESERVARFORAHORES.SHOW", "", "fa-clock-o", 50, 0, -1, ""));
      }
      if (this.canShowPropertiesButton) {
         this.actions.add(ActionDto.build("PROPERTIES", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.PROPERTIES", "", "", 15, -1, 0, "").actionGO());
      }
      if (!this.showReservarForaHores) {
         this.actions.add(ActionDto.build("RELOAD", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.RELOAD", "", "fa-refresh", 10, 1, 0, "").default());
         if (this.canSlotRelease)
            this.actions.add(ActionDto.build("CANCEL", "DESKTOP.SLOT.PICKER.COMPONENT.BUTTON.CANCEL", "", "fa-ban", 20, 0, 0, "").danger());
      }
   }
   public onClickAction(action: ActionDto) {
      if (action == null)
         return;
      if (action.actionId === "RELOAD")
         this.reload();
      else if (action.actionId === "CANCEL")
         this.clickAlliberarSlot();
      else if (action.actionId === "PROPERTIES")
         this.homeController.openAsideRouteProperties(this.phase.routeId).then(value => {
            this.reload();
         });
      else if (action.actionId === "REESERVARFORAHORES")
         this.toggleReservarForaHores();
   }
   pretty(value) {
      return JSON.stringify(value);
   }
}
